import {ServiceBase} from '../base/service.base';
import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class CommentService extends ServiceBase {
    constructor(http: HttpClient) {
        super(http);
    }

    get(id: string): any {
        const url = `${this.BASE_URL}/comment/${id}`;
        return this.http.get(url);
    }

    search(page: number = 1, model): any {
        const url = `${this.BASE_URL}/comment/search/${page}`;
        return this.http.post(url, model);
    }

    create(model): any {
        const url = `${this.BASE_URL}/comment/create`;
        return this.http.post(url, model);
    }

    update(model, id): any {
        const url = `${this.BASE_URL}/comment/update/${id}`;
        return this.http.put(url, model);
    }

    delete(id: string, lang: string): any {
        const url = `${this.BASE_URL}/comment/${id}/${lang}`;
        return this.http.delete(url);
    }

    upload(file, id): any {
        const url = `${this.BASE_URL}/comment/${id}/upload`;
        return new Observable((observer) => {
            // tslint:disable-next-line:one-variable-per-declaration
            const formData: FormData = new FormData(),
                xhr: XMLHttpRequest = new XMLHttpRequest();

            if (file != null) {
                formData.append('file', file, file.name);
            }

            xhr.onreadystatechange = () => {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        observer.next(JSON.parse(xhr.response));
                        observer.complete();
                    } else {
                        observer.error(xhr.response);
                    }
                }
            };

            xhr.upload.onprogress = (event) => {
                const progress = Math.round(event.loaded / event.total * 100);
            };

            xhr.open('POST', url, true);
            xhr.setRequestHeader('Authorization', 'Bearer ' + this.getToken());
            xhr.send(formData);
        });
    }
}
